const dictionaries = {
  en: () => import('../../dictionaries/combined/en.json').then(module => module.default),
  tr: () => import('../../dictionaries/combined/tr.json').then(module => module.default),
} as const

export type Locale = keyof typeof dictionaries

export const getDictionary = async (locale: Locale): Promise<Dictionary> => dictionaries[locale]()
